<template>
  <!-- 碎片活动管理-添加公式 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="添加公式"
      width="400px"
      @close="closeDialog"
    >
      <el-form
        :model="dataForm"
        ref="dataForm"
        label-width="100px"
        size="small"
        :rules="replyRules"
      >
        <el-form-item label="奖品信息">
          <AddGoods
            :prizeInfo="dataForm.prize"
            @selectedData="getSelectedData"
          ></AddGoods>
        </el-form-item>
        <el-form-item label="需要的碎片">
          <div
            class="selected-debris-box"
            v-for="(item, index) in dataForm.content"
            :key="index"
          >
            <img :src="item.image" alt="" />
            <span>{{ item.name }}</span>
            <span style="margin-left: 5px; color: green">{{
              "x" + item.num
            }}</span>
            <span class="delete-btn" @click="deleteItem(index)">删除</span>
          </div>
          <AddDebris
            v-if="dataForm.content.length < 6"
            @selectedDebrisData="getSelectedDebrisData"
          ></AddDebris>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import { getCookie } from '../../utils/cookie'
import saveFile from '@/utils/saveFile'
import AddGoods from '../../components/goods/AddGoods.vue'
import AddDebris from '../../components/debrisActivity/AddDebris.vue'

export default {
  components: {
    AddGoods,
    AddDebris
  },
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//弹窗类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      imgType: 'prize',//上传图片的种类 奖品
      dataForm: {
        prize_id: '',
        content: [],
        prize: undefined
      },
      replyRules: {//回复弹窗规则验证
      }
    }
  },
  computed: {
    ...mapState({
    }),
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${server}file`
    },
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    fromInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val && this.fromInfo) {
        this.dataForm = this.fromInfo
      } else if (val && !this.fromInfo) {
        this.dataForm = {
          prize_id: '',
          content: [],
          prize:undefined
        }
      }
    },
  },
  created() {
  },
  methods: {
    submit() {
      //保存任务
      //表单验证后发起请求
      this.buttonLoading = true
      let params = this.dataForm

      if (this.type === 1) {
        postApiData('debris_goods', params).then(res => {
          this.$message.success("添加成功")
          this.$emit('refresh')
          this.closeDialog()
        }).finally(() => {
          this.buttonLoading = false
        })
      } else if (this.type === 2) {
        patchApiData(`debris_goods/${this.dataForm.id}`, params).then(res => {
          this.$message.success("编辑成功")
          this.$emit('refresh')
          this.closeDialog()
        }).finally(() => {
          this.buttonLoading = false
        })
      }
    },
    getSelectedData(data) {
      //选择物品数据
      this.dataForm.prize_id = data.id
    },
    getSelectedDebrisData(data) {
      // 选择碎片数据
      if (this.dataForm.content.length >= 6) {
        this.$message.error("最多选择六个碎片")
        return
      }
      this.dataForm.content.push(data)
    },
    deleteItem(index) {
      this.dataForm.content.splice(index, 1)
    },
    beforeImageUpload(file) {
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error('图片尺寸过大，请选择2M大小以下的图片上传')
        return false
      }
    },
    handleUploadSuccess(res) {
      if (res.path) {
        this.dataForm.image = res.path
      } else {
        this.$message.error('上传失败')
      }
      this.$refs['dataForm'].validateField('image')
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
.selected-debris-box {
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-bottom: 5px;
  line-height: 20px;
  img {
    width: 50px;
    margin-right: 10px;
  }
  .delete-btn {
    cursor: pointer;
    flex-shrink: 0;
    margin-left: 10px;
    color: rgba(255, 0, 0, 0.8);
    &:hover {
      color: rgba(255, 0, 0, 1);
    }
  }
}
</style>